export function guestCount(value) {
  const n = Number(value);
  return Number.isSafeInteger(n) && n > 0 ? n : null;
}

export function groupSizeBucket(value) {
  const n = guestCount(value);
  if (!n) return null;
  if (n <= 10) return '1_10';
  if (n <= 25) return '11_25';
  if (n <= 50) return '26_50';
  if (n <= 100) return '51_100';
  return '101_plus';
}

// These rules mirror Event#calculate_price_for_guests. Unknown or unavailable
// prices remain unknown; a missing smart-pricing tier must not become $0.
export function estimatePrice(data, value) {
  const guests = guestCount(value);
  if (!guests) return null;
  const minimum = Number(data.estimateMinGuests) || 1;
  const maximum = Number(data.estimateMaxGuests) || Infinity;
  if (guests > maximum) return null;
  const billedGuests = Math.max(guests, minimum);
  let total;
  if (data.estimateSmartTiers) {
    let tiers;
    try { tiers = JSON.parse(data.estimateSmartTiers); } catch { return null; }
    const tier = tiers.find(t => billedGuests >= t.min_guests && (!t.max_guests || billedGuests <= t.max_guests));
    if (!tier) return null;
    total = Number(tier.price) * (tier.price_type === 'flat_rate' ? 1 : billedGuests);
  } else if (Number(data.estimateFlat) > 0) {
    total = Number(data.estimateFlat);
  } else if (Number(data.estimateFlatPlusBase) > 0) {
    total = Number(data.estimateFlatPlusBase) + Math.max(0, billedGuests - Number(data.estimateFlatPlusIncluded || 0)) * Number(data.estimateFlatPlusAdditional || 0);
  } else if (Number(data.estimatePerPerson) > 0) {
    const rate = Number(data.estimatePerPerson);
    const extraRate = data.estimateAdditionalRate ? Number(data.estimateAdditionalRate) : rate;
    total = Math.min(billedGuests, 50) * rate + Math.max(0, billedGuests - 50) * extraRate;
  }
  return Number.isFinite(total) && total >= 0 ? { total: Math.round(total * 100) / 100, guests, billedGuests } : null;
}
